module.exports = __webpack_public_path__ + "img/orange_026.c7774ca2.png";